import { createGenericSelector } from '~/containers/GenericFetch/selectors';

const getKey = () => 'active';

export const selectRounds = createGenericSelector('Round', 'data', getKey);
export const selectError = createGenericSelector('Round', 'error', getKey);
export const selectLoading = createGenericSelector('Round', 'fetching', getKey);
